import { Archive as ArchiveComponent } from '../../components/Widgets/Archive'
import { GenericWrapper } from './styles'

export function Archive(): React.ReactNode {
  return (
    <GenericWrapper>
      <ArchiveComponent />
    </GenericWrapper>
  )
}
